import { globalVariables, globalVariablesBytes } from "./globals";
import { BackOutputVariableBaseAddress, BackOutputVariableBaseBytes32, ComputedBaseAddress, ComputedBaseBytes32, ExternalVariableBaseAddress, ExternalVariableBaseBytes32, OutputVariableBaseAddress, OutputVariableBaseBytes32, } from "./constants";
// Global Variables
export var getBlockNumber = function () { return ({ type: 'global', id: 'blockNumber' }); };
export var getBlockTimestamp = function () { return ({ type: 'global', id: 'blockTimestamp' }); };
export var getGasPrice = function () { return ({ type: 'global', id: 'gasPrice' }); };
export var getMinerAddress = function () { return ({ type: 'global', id: 'minerAddress' }); };
export var getOriginAddress = function () { return ({ type: 'global', id: 'originAddress' }); };
export var getInvestorAddress = function () { return ({ type: 'global', id: 'investorAddress' }); };
export var getActivatorAddress = function () { return ({ type: 'global', id: 'activatorAddress' }); };
export var getEngineAddress = function () { return ({ type: 'global', id: 'engineAddress' }); };
export var getChainID = function () { return ({ type: 'global', id: 'chainId' }); };
export var getFlowHash = function () { return ({ type: 'global', id: 'flowHash' }); };
export var getRandomNumber = function () { return ({ type: 'global', id: 'randomNumber' }); };
export var getL1BlockNumber = function () { return ({ type: 'global', id: 'l1BlockNumber' }); };
export var getFctMaxGasPrice = function () { return ({ type: 'global', id: 'fctMaxGasPrice' }); };
/**
 * Generates the output variable based on the provided call index and inner index.
 * @param {number} index - The index of the call.
 * @param {number} innerIndex - The index of the slot of the result.
 * @param {string} type - The type of the output variable. Defaults to "uint256".
 * @returns {string} - The output variable.
 */
export function getOutputVariable(_a) {
    var index = _a.index, offset = _a.offset, _b = _a.type, type = _b === void 0 ? 'uint256' : _b;
    var outputIndexHex = (index + 1).toString(16).padStart(4, '0');
    var base;
    var offsetHex;
    if (offset < 0) {
        offset = offset + 32 > 0 ? 0 : offset + 32;
        offsetHex = (offset * -1).toString(16).padStart(5, '0');
        base = type === 'address' ? BackOutputVariableBaseAddress : BackOutputVariableBaseBytes32;
    }
    else {
        offsetHex = (offset + 32).toString(16).padStart(4, '0');
        base = type === 'address' ? OutputVariableBaseAddress : OutputVariableBaseBytes32;
    }
    return (offsetHex + outputIndexHex).padStart(base.length, base);
}
/**
 * Retrieves the external variable based on the provided index and type.
 * @param {number} index - The index of the external variable.
 * @param {string} type - The type of the parameter.
 * @returns {string} - The external variable.
 */
export function getExternalVariable(_a) {
    var index = _a.index, type = _a.type;
    var outputIndexHex = (index + 1).toString(16).padStart(4, '0');
    var base = type === 'address' ? ExternalVariableBaseAddress : ExternalVariableBaseBytes32;
    return outputIndexHex.padStart(base.length, base);
}
/**
 * Retrieves the computed variable based on the provided index and type.
 * @param {number} index - The index of the computed variable.
 * @param {string} type - The type of the parameter.
 * @returns {string} - The computed variable.
 */
export function getComputedVariable(_a) {
    var index = _a.index, type = _a.type;
    var outputIndexHex = (index + 1).toString(16).padStart(4, '0');
    var base = type === 'address' ? ComputedBaseAddress : ComputedBaseBytes32;
    return outputIndexHex.padStart(base.length, base);
}
/**
 * Retrieves the value of a global variable based on its ID and type.
 * @param {string} id - The ID of the global variable.
 * @param {string} type - The type of the parameter.
 * @returns {string} The value of the global variable.
 * @throws If the global variable does not exist.
 */
export function getGlobalVariable(_a) {
    var id = _a.id, type = _a.type;
    if (type.includes('bytes')) {
        if (!(id in globalVariablesBytes)) {
            throw new Error("Global variable ".concat(id, " does not support bytes"));
        }
        return globalVariablesBytes[id];
    }
    var globalVariable = globalVariables[id];
    if (!globalVariable) {
        throw new Error('Global variable not found');
    }
    return globalVariable;
}
